import { repubs } from '@cx-web/utils';

import { type Repub } from '@cx-modules/types';

export const getUrlWithRepub = (baseUrl: string, repub: Repub) => {
  const repubPath = repubs.find(([repubCode]) => repubCode === repub)?.[1];

  if (!repubPath) {
    return `/${repub.toLowerCase()}`;
  }

  if (repubPath === '/') {
    return baseUrl;
  }

  // Remove trailing slash from the path
  return `/${repubPath.replace(/\/$/, '')}`;
};
